import { ApolloClient, InMemoryCache, createHttpLink, from } from '@apollo/client';
import { setContext } from '@apollo/client/link/context';

// HTTP 링크 생성 - 도메인에 따라 자동 선택
const getGraphQLUri = () => {
  if (process.env.REACT_APP_GRAPHQL_URI) {
    return process.env.REACT_APP_GRAPHQL_URI;
  }
  
  // 현재 브라우저의 호스트명에 따라 GraphQL URI 결정
  const hostname = window.location.hostname;
  if (hostname === 'www.busbarworld.com') {
    return 'https://www.busbarworld.com/api/graphql';
  } else if (hostname === 'busbarworld.com') {
    return 'https://busbarworld.com/api/graphql';
  }
  
  // 기본값 (로컬 개발 또는 기타 환경)
  return 'http://localhost:4000/graphql';
};

const httpLink = createHttpLink({
  uri: getGraphQLUri(),
});

// 인증 링크 생성 - JWT 토큰을 헤더에 추가
const authLink = setContext((_, { headers }) => {
  // 로컬 스토리지에서 토큰 가져오기
  const token = localStorage.getItem('authToken');
  
  return {
    headers: {
      ...headers,
      authorization: token ? `Bearer ${token}` : "",
    }
  }
});

// Apollo Client 인스턴스 생성 (인증 활성화됨)
const client = new ApolloClient({
  link: from([authLink, httpLink]),
  cache: new InMemoryCache({
    typePolicies: {
      User: {
        fields: {
          cartItems: {
            merge(existing, incoming) {
              return incoming;
            }
          }
        }
      },
      SystemSettings: {
        // SystemSettings는 단일 인스턴스이므로 ID 필드 지정
        keyFields: ["id"],
        fields: {
          // 모든 필드가 완전히 대체되도록 설정
          companyName: {
            merge(existing, incoming) {
              return incoming;
            }
          },
          businessNumber: {
            merge(existing, incoming) {
              return incoming;
            }
          },
          address: {
            merge(existing, incoming) {
              return incoming;
            }
          },
          phone: {
            merge(existing, incoming) {
              return incoming;
            }
          },
          fax: {
            merge(existing, incoming) {
              return incoming;
            }
          },
          email: {
            merge(existing, incoming) {
              return incoming;
            }
          },
          businessHours: {
            merge(existing, incoming) {
              return incoming;
            }
          },
          businessDays: {
            merge(existing, incoming) {
              return incoming;
            }
          },
          copyright: {
            merge(existing, incoming) {
              return incoming;
            }
          }
        }
      }
    }
  }),
  defaultOptions: {
    watchQuery: {
      errorPolicy: 'all',
      fetchPolicy: 'network-only' // 항상 서버에서 최신 데이터 가져오기
    },
    query: {
      errorPolicy: 'all',
      fetchPolicy: 'network-only'
    }
  }
});

export default client; 